import { FieldType } from '@ngx-formly/material';

import { Component, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';

import { ISnSelectFormFieldConfig } from '../../interfaces/select-form-field-config.interface';
import { ISnSelectTemplateOptions } from '../../interfaces/select-template-options.interface';

@Component({
  selector: 'sn-select-form-field',
  templateUrl: './select.form-field.html',
  styleUrls: ['./select.form-field.scss'],
})
export class SnSelectFormField extends FieldType<ISnSelectFormFieldConfig> implements OnInit {
  public selectOptions = [];

  public readonly defaultOptions: ISnSelectFormFieldConfig = {
    type: 'select',
    templateOptions: {
      appearance: 'fill',
      valueProp: 'value',
      labelProp: 'label',
      options: [],
      multiple: false,
      selectAllOption: '',
      emptyOption: false,
      emptyLabel: '',
    },
  };

  constructor() {
    super();
  }

  get templateOptions(): ISnSelectTemplateOptions {
    return this.field.templateOptions;
  }

  public ngOnInit(): void {}

  public trackOption(index: number, item: { label: string; value: any }): any {
    return item.value;
  }

  public getState(options: any[]): string {
    if (!this.formControl.value || !this.formControl.value.length) {
      return;
    }

    return this.formControl.value.length !== options.length ? 'indeterminate' : 'checked';
  }

  public toggleSelectAll(options: any[]): void {
    const isSelectedAll =
      !!this.formControl.value && this.formControl.value.length === options.length;

    if (isSelectedAll) {
      this.formControl.reset();
    } else {
      const values = options.map((option) => option.value);

      this.formControl.setValue(values);
    }
  }

  public change($event: MatSelectChange): void {
    if (this.to.change) {
      this.to.change(this.field, $event);
    }
  }

  public clearList(): void {
    this.formControl.reset();
  }

  public compareWith(oldOption: string, newOption: string): boolean {
    return oldOption === newOption;
  }
}
